import React from 'react';
import { declMod } from '@yandex-lego/i-bem-react';
import _userPic__camera from "./../__camera/user-pic__camera.react.js";

var Camera = _userPic__camera.applyDecls();

import "./../__camera/user-pic__camera.css";
import "./../../../desktop.blocks/user-pic/__camera/user-pic__camera.css";
export default declMod({
  camera: true
}, {
  block: 'user-pic',
  content: function content(_ref) {
    var origin = _ref.origin,
        avatarId = _ref.avatarId;

    if (!avatarId || avatarId === '0/0-0') {
      return [this.__base.apply(this, arguments), React.createElement(Camera, {
        origin: origin || 'userpic',
        key: "camera"
      })];
    }

    return this.__base.apply(this, arguments);
  }
});